export default __webpack_public_path__ + "static/media/question.f79b7187.svg";